// constants.js
import {
    BackendIcon,
    DeploymentIcon,
    FrontendIcon,
    IdeationIcon,
    MaintenanceIcon,
    UIDesignIcon
  } from "../icons";
  
  export const colors = {
    purple: "#FDC400",
    blue: "#218AE5",
    green: "#28a728",
    orange: "#001F3F",
    red: "#4682B4",
    pink: "#708090",
    white: "#fff"
  };
  
  export const boxesData = [
    {
      color: "purple",
      number: 1,
      title: "Ideation",
      description: 'Turn your groundbreaking idea into a software powerhouse—fuel innovation and lead the future of digital disruption.',
      icon: <IdeationIcon color={colors.white} />,
      desktop: { x: 50, y: 40 },
      mobile: { x: 20, y: 80 }
    },
    {
      color: "blue",
      number: 2,
      title: "UI Design",
      description: 'Create stunning UI designs that captivate at first glance—transforming user journeys into unforgettable experiences.',
      icon: <UIDesignIcon color={colors.white} />,
      desktop: { x: 750, y: 210 },
      mobile: { x: 20, y: 630 }
    },
    {
      color: "green",
      number: 3,
      title: "Frontend",
      description: 'Elevate user experiences with cutting-edge frontend design—crafted to dazzle, perform, and drive engagement.',
      icon: <FrontendIcon color={colors.white} />,
      desktop: { x: 50, y: 410 },
      mobile: { x: 20, y: 1190 }
    },
    {
      color: "orange",
      number: 4,
      title: "Backend",
      description: 'Unleash the full potential of your software with a backend engineered for unmatched speed, scalability, and security.',
      icon: <BackendIcon color={colors.white} />,
      desktop: { x: 750, y: 590 },
      mobile: { x: 20, y: 1750 }
    },
    {
      color: "red",
      number: 5,
      title: "Deployment",
      description: 'Take your product live with seamless, zero-downtime deployment—ensuring your software success from day one.',
      icon: <DeploymentIcon color={colors.white} />,
      desktop: { x: 50, y: 780 },
      mobile: { x: 20, y: 2310 }
    },
    {
      color: "pink",
      number: 6,
      title: "Maintenance",
      description: 'Stay ahead with proactive maintenance keeping your software flawless and unstoppable in any environment.',
      icon: <MaintenanceIcon color={colors.white} />,
      desktop: { x: 750, y: 950 },
      mobile: { x: 20, y: 2870 }
    }
  ];
  
  export const desktopPaths = [
    { path: "M180 285 v26 q0 25 25 25 h545", color: "purple", delay: "0.5s" },
    { path: "M50 280 v-240 h240 v240 h-240", color: "purple", delay: "0.5s" },
    { path: "M880 450 v26 q0 25 -25 25 h-565", color: "green", delay: "1.5s" },
    { path: "M750 210 h240 v240 h-240 v-240", color: "blue", delay: "1.5s" },
    { path: "M180 650 v26 q0 25 25 25 h545", color: "orange", delay: "3.5s" },
    { path: "M50 410 h240 v240 h-240 v-240", color: "green", delay: "3.5s" },
    { path: "M880 835 v26 q0 25 -25 25 h-565", color: "red", delay: "5s" },
    { path: "M750 590 h240 v240 h-240 v-240", color: "orange", delay: "5s" },
    { path: "M180 1020 v26 q0 25 25 25 h545", color: "pink", delay: "6s" },
    { path: "M50 780 h240 v240 h-240 v-240", color: "red", delay: "6s" },
    { path: "M750 950 h240 v240 h-240 v-240", color: "pink", delay: "7s" }
  ];
  
  export const mobilePaths = [
    { path: "M387 500 v130 q0 0 1 0", color: "purple", delay: "1.5s" },
    { path: "M387 1050 v140 q0 0 1 0", color: "blue", delay: "2.5s" },
    { path: "M387 1610 v140 q0 0 1 0", color: "green", delay: "3.5s" },
    { path: "M387 2170 v140 q0 0 1 0", color: "orange", delay: "4.5s" },
    { path: "M387 2730 v140 q0 0 1 0", color: "red", delay: "5.5s" },
  ];
  